var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52 6.9h6.24V5.01H2.53v1.9zm0 4.04h6.24V9.06H2.53v1.88zm0 4.05h6.24v-1.9H2.53V15zm8.71-9.98v1.9h6.24V5h-6.24zm0 5.93h6.24V9.06h-6.24v1.88zm0 4.05h6.24v-1.9h-6.24V15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default ForwardRef;